import { CSS, StyleProps } from "@shared/primitive-components"

export const container = () => ({
  width: `100vw`,
  minHeight: `100vh`,
})

export const formContainer = (props: StyleProps): CSS => ({
  width: `45vw`,
  padding: props.theme.spacing(10),
  flex: 1,
  flexDirection: `column`,
  marginTop: props.theme.spacing(10),
})

export const portalName = (props: StyleProps): CSS => ({
  ...props.theme.fonts.subHeading,
  fontSize: props.theme.fontSize.subtitle,
  color: props.theme.palette.grey.dark,
  marginBottom: props.theme.pxToEm(25),
})

export const title = (props: StyleProps) => ({
  fontSize: props.theme.fontSize.large,
  ...props.theme.fonts.heading,
  letterSpacing: `-2px`,
  marginTop: props.theme.pxToEm(54),
  marginBottom: props.theme.pxToEm(40),
})

export const textWrap = (props: StyleProps) => ({
  marginBottom: props.theme.pxToEm(60),
})

export const instructions = (props: StyleProps) => ({
  fontSize: props.theme.fontSize.subtitle,
  color: props.theme.palette.grey.dark,
  lineHeight: props.theme.pxToEm(30),
})

export const marginBottom = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(6),
})

export const success = (props: StyleProps) => ({
  color: props.theme.palette.valid,
})

export const error = (props: StyleProps) => ({
  color: props.theme.palette.error,
})

export const buttonWrapper = (props: StyleProps): CSS => ({
  alignItems: `flex-end`,
  marginTop: props.theme.spacing(4),
  flexDirection: `column`,
  marginBottom: props.theme.pxToEm(40),
})

export const logoWrapper = (props: StyleProps) => ({
  width: `55vw`,
  backgroundColor: props.theme.palette.brand,
  padding: props.theme.spacing(10),
  alignItems: `flex-end`,
  justifyContent: `flex-end`,
})
